import React, { useEffect, useState } from "react";
import axios from "axios";
import { Sparkles, ChevronDown } from "lucide-react";
import AccuracyVote from "./AccuracyVote";
import { useI18n } from "../contexts/I18nContext";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// The first thing a visitor reads about themselves — a real 60-word reading,
// delivered before any signup ask.
export const FirstReadCard = ({ chart, reportId, name, reportMd, showScrollHint = false }) => {
  const { t, lang } = useI18n();
  const [teaser, setTeaser] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!chart && !reportId && !reportMd) { setLoading(false); return; }
    let alive = true;
    setLoading(true);
    axios.post(`${API}/kundli/teaser`, {
      chart_json: chart || undefined, report_id: reportId || undefined,
      report_md: reportMd || undefined, lang,
    }, { withCredentials: true })
      .then(r => { if (alive) setTeaser(r.data?.teaser || ""); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [chart, reportId, reportMd, lang]);

  if (!loading && !teaser) return null;

  return (
    <div data-testid="first-read-card" className="glass-card animate-fadeInUp" style={{
      marginBottom: "18px", padding: "18px 20px",
      border: "1px solid rgba(255,209,102,0.35)",
      background: "linear-gradient(135deg, rgba(255,209,102,0.09), rgba(157,78,221,0.07))",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "9px" }}>        <Sparkles size={15} style={{ color: "#FFD166" }} />
        <span className="font-cinzel" style={{ color: "#FFD166", fontSize: "0.98rem" }}>
          {name ? `${name} — ${t("chart.firstRead")}` : t("chart.firstRead")}
        </span>
      </div>
      {loading ? (
        <p data-testid="first-read-loading" style={{ color: "rgba(255,255,255,0.45)", fontSize: "0.88rem" }}>
          {lang === "hi" ? "आपकी कुंडली पढ़ रहे हैं…" : "Reading your chart…"}
        </p>
      ) : (
        <>
          <p data-testid="first-read-text" style={{ color: "rgba(255,255,255,0.86)", fontSize: "0.94rem", lineHeight: 1.75 }}>
            {teaser}
          </p>
          {showScrollHint && (
            <div data-testid="first-read-scroll-hint" style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "10px", color: "#FFD166", fontSize: "0.82rem", fontWeight: 700 }}>
              <ChevronDown size={15} className="animate-bounce" />
              {lang === "hi" ? "पूरी कुंडली रिपोर्ट नीचे देखें" : "Scroll down for your complete Kundli report"}
            </div>
          )}
          <div style={{ marginTop: "12px" }}>
            <AccuracyVote kind="report" reportId={reportId} compact />
          </div>
        </>
      )}
    </div>
  );
};

export default FirstReadCard;
